import stringifyObjectUtil from '../stringify'

function getStringifiedPropertiesObjectUtil (obj, options = {}) {
  const depth = options.depth || 0
  const shouldCompact = (
    options.shouldCompact != null
      ? options.shouldCompact
      : true
  )
  if (
    !obj ||
    typeof obj !== 'object' ||
    obj instanceof Error
  ) {
    return obj
  }

  if (Array.isArray(obj) && depth < 1) {
    return obj.map(stringifyObjectUtil)
  }

  if (Array.isArray(obj)) {
    return stringifyObjectUtil(obj)
  }

  return Object.keys(obj).reduce((newObj, key) => {
    const value = obj[key]
    const isObject = typeof value === 'object'
    if ((value == null || Number.isNaN(value)) && shouldCompact) {
      return newObj
    }
    if (value && isObject && depth < 1) {
      newObj[key] = getStringifiedPropertiesObjectUtil(obj[key], {
        ...options,
        depth: depth + 1
      })
    } else if (obj[key] && isObject) {
      newObj[key] = stringifyObjectUtil(obj[key])
    } else {
      newObj[key] = obj[key]
    }
    return newObj
  }, {})
}

export default getStringifiedPropertiesObjectUtil
